module.exports = "<div class=\"bottomright\">\n  <div *ngFor=\"let notification of service.Notifications\" class=\"alert {{GetType(notification)}} alert-dismissible\" [style.opacity]=\"notification.Opacity\"\n    role=\"alert\">\n    {{notification.Message}}\n    <button (click)=\"Close(notification)\" type=\"button\" class=\"close\" aria-label=\"Close\">\n      <span aria-hidden=\"true\">&times;</span>\n    </button>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/OTHERS/FirstmediaShowSchedule/src/app/notification/notification.component.html
// module id = ../../../../../src/app/notification/notification.component.html
// module chunks = main